/**
 * Lit un fichier en data-URI base64 : la forme sous laquelle les images
 * téléversées (logos, fonds d'attestation, captures jointes au support) partent
 * dans les mutations GraphQL.
 */
export function readFileAsDataUri(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
}
